import React from 'react';
import PropTypes from 'prop-types';

import { useUploadDocumentContext } from '../context';

import DestinationStep from './DestinationStep';
import DetailsStep from './DetailsStep';
import DocumentTitleStep from './DocumentTitleStep';
import UploadStep from './UploadStep';

const RenderStep = ({ form, values }) => {
  const { step } = useUploadDocumentContext();

  switch (step) {
    case 1:
      return <UploadStep />;
    case 2:
      return <DocumentTitleStep />;
    case 3:
      return <DestinationStep form={form} />;
    case 4:
      return <DetailsStep values={values} />;
    default:
      return null;
  }
};

RenderStep.propTypes = {
  form: PropTypes.object,
  values: PropTypes.object,
};

export default RenderStep;
